import cn from 'classnames';
import Link from 'next/link';
import { useSelector } from 'react-redux';
import { getRoleUrl } from '../../data/getRole';

const Town = ({ town, showDivider, urlPath }) => {
    return (
        <div key={town.name} className='inline-block'>
            {
                showDivider &&
                <span className={cn({ ['text-secondary-blue mx-1']: true, ['max-xs:hidden']: urlPath })}>&#8226;</span>
            }
            {
                urlPath
                ? <Link href={`${urlPath}/${town.name.toLowerCase()}`}>
                    <a className='no-underline text-secondary-blue cursor-pointer max-md:pr-[2px] max-xs:m-2 max-xs:block'>{ town.name }</a>
                </Link>
                : <span className='text-primary-blue'>{town.name}</span>
            }
        </div>
    );
};

const LocalTownsList = ({ vertical_id, label, enableLinks }) => {
    const towns = useSelector(state => state.search.localTowns);

    if (!towns.length) {
        return null;
    }

    return (
        <div className='flex items-center max-xs:items-start max-xs:flex-col'>
            <span className='pr-4 max-md:pr-2'>
                <strong>{ label }</strong>
            </span>
            <div>
                <div className={cn({ ['inline-block']: true, ['flex flex-wrap -ml-2']: enableLinks })}>
                    {
                        towns.map((town, i) =>
                            <Town
                                key={`${town}-${i}`}
                                town={town}
                                urlPath={enableLinks ? getRoleUrl(vertical_id) : null}
                                showDivider={i !== 0}
                            />
                        )
                    }
                    {
                        towns.length > 9 && !enableLinks &&
                        <span className='max-xs:ml-1 ml-4'>+ more</span>
                    }
                </div>
            </div>
        </div>
    );
};

export default LocalTownsList;
